// Types
import { isEmpty } from 'lodash';
import { IAoyAnglerRank, IBasstrakkAngler, IBasstrakkCatch } from '../types';

/**
 * Combines api data for the "Basstrakk Standings" table
 *
 * @param {IBasstrakkAngler[]} anglers
 * @param {IBasstrakkCatch[]} catches
 * @param {IAoyAnglerRank[] | []} aoy
 */
const useBasstrakkTableData = (
  anglers: IBasstrakkAngler[],
  catches: IBasstrakkCatch[],
  aoy?: IAoyAnglerRank[]
) =>
  anglers && anglers.length
    ? anglers.map(angler => {
        const id = angler.FISHERMENID;
        const anglerCatches = catches?.filter(c => c.AnglerId === id);
        // Find the leading catch
        const leader = !isEmpty(catches)
          ? catches.reduce((prev, current) => {
              return prev.FishWeightOz > current.FishWeightOz ? prev : current;
            })
          : {};
        const aoyStanding = aoy ? aoy.filter(s => Number(s.FISHERMENID) === id) : [];
        return {
          ...angler,
          Catches: anglerCatches,
          AoyStanding: aoyStanding && aoyStanding.length ? aoyStanding[0] : [],
          BigBassLeader: leader,
        };
      })
    : [];

export default useBasstrakkTableData;
